/**
 * Indicates the direction of the activation (based on the previous active tab).
 * @type {'left' | 'right' | 'up' | 'down' | 'none'}
 */
export const activationDirection = 'data-activation-direction';
/**
 * Indicates the orientation of the tabs.
 * @type {'horizontal' | 'vertical'}
 */
export const orientation = 'data-orientation';